var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selected-user-badge",style:({ cursor: _vm.user.premiumAccount ? 'unset' : 'pointer' })},[_c('div',{staticClass:"selected-user-badge-text",on:{"click":function($event){$event.stopPropagation();return _vm.onUserTypeClicked.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.userType))])])
}
var staticRenderFns = []

export { render, staticRenderFns }